import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";

const Header = ({ hideRunmainbtn,HandleNewdata,  SHOWSETTINGTAB,HideDignosticbtn,HideALLBTNS, selectedRows, onButtonClick, handleRunSelfDiagnostics={handleRunSelfDiagnostics}, handleRunMaintenance={handleRunMaintenance}, HideTab, onSearchChange, searchValue, HeaderBTNCLICK,selecteFilter }) => {
  const buttons = [
    { name: "Network Switches", key: "network" },
    { name: "AV Devices", key: "av" },
    { name: "PDU Devices", key: "pdu" },
  ];
  const location = useLocation();
  const isActive = location.pathname;

  const Setting_buttons = [
    { name: "Devices", Link: "/settings/Devices" },
    { name: "Firmwares", Link: "/settings/Firmwares" },
   
  ];

  let initialActiveButton = 'av';
  const [activeButton, setActiveButton] = useState(initialActiveButton);
  const [searchTerm, setSearchTerm] = useState(searchValue || '');



  useEffect(() => {
    setActiveButton(initialActiveButton);
    setSearchTerm(searchValue || '');
  }, [initialActiveButton, searchValue]);

  const handleButtonClick = (button) => {
    setActiveButton(button.key);

    if (onButtonClick) {
      onButtonClick(button.key); // Send the active button name to the parent
    }
  };


  



  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    if (onSearchChange) {
      onSearchChange(e.target.value); // Send the search term to the parent
    }
  };



  

  const isButtonDisabled = selectedRows?.length === 0;
  return (

    <> 
    
    
    {/* <MaintenancePopup   isOpen={isOpen} onClose={() => setIsOpen(false)} /> */}
      <section className="w-full  bg-SoftBlack">

        {/* Button Group */}
        <ul className={`w-full flex items-center md:pt-0 pt-4 ${HideTab && `hidden`}`}>
          {buttons.map((button) => (
            <li
              key={button.key}
              className={` md:text-xl text-sm md:px-0 px-2 text-white w-full items-center text-center flex justify-center h-[2.75rem] ${activeButton === button.key ? "border-b-4 border-DarkRed" : "border-b-4 opacity-35"}`}
            >
              <button onClick={() => handleButtonClick(button)}>{button.name}</button>
            </li>
          ))}
        </ul>



        <ul className={`w-full flex items-center md:pt-0 pt-4 ${SHOWSETTINGTAB ? 'flex':'hidden'}`}>
          {Setting_buttons.map((button) => (
            <Link
              key={button.name}
              to={button.Link}
              className={` md:text-xl text-sm md:px-0 px-2 text-white w-full items-center text-center flex justify-center h-[2.75rem] ${isActive === button.Link ? "border-b-4 border-DarkRed" : "border-b-4 opacity-35"}`}
            >
              {button.name}
            </Link>
          ))}
        </ul>
      

        {/* Search and Control Buttons */}
        <div className="flex px-4 lg:px-16 flex-col md:flex-row justify-between items-center py-5 text-white">
          {/* Search and Maintenance Buttons */}
          <div className="flex flex-col sm:flex-row items-center gap-4">
            <div className="flex items-center bg-gray-700 border border-white border-opacity-35 rounded-full px-4 py-2 w-full sm:w-72">
              <img className="mr-2 w-5 h-5" src="/Icons/search.svg" alt="search" />
              <input
                type="text"
                placeholder="Search here..."
                className="bg-transparent focus:outline-none text-white w-full"
                value={searchTerm}
                onChange={handleSearchChange}
              />
            </div>


            <div className={`flex items-cente ${SHOWSETTINGTAB ? 'flex':'hidden'}`}>
           
             <button onClick={HandleNewdata}
                className={` bg-DarkRed text-sm md:text-base rounded-full px-4 py-2 transition-colors `}
             
              >
                Add New Data
              </button>
            </div>



            <div className={`flex gap-2 ${HideALLBTNS && 'hidden'}`}>
              <button
                className={`text-sm md:text-base rounded-full px-4 py-2 transition-colors ${isButtonDisabled
                    ? "bg-gray-500 cursor-not-allowed"
                    : "bg-blue-600 hover:bg-blue-700"
                  } ${hideRunmainbtn && 'hidden'}`}
                onClick={handleRunMaintenance}
                disabled={isButtonDisabled}
              >
                Run Maintenance
              </button>
              <button
                className={`text-sm md:text-base rounded-full px-4 py-2 transition-colors ${isButtonDisabled
                    ? "bg-gray-500 cursor-not-allowed"
                    : "bg-blue-600 hover:bg-blue-700"
                  } ${HideDignosticbtn && `hidden`}`}
                onClick={handleRunSelfDiagnostics}
                disabled={isButtonDisabled}
              >
                Run Self Diagnostics
              </button>
            </div>


            
          </div>

          {/* Icon Buttons */}
          <ul className="flex max-md:px-14  max-md:w-full items-center justify-evenly gap-2 mt-4 md:mt-0">
            {["excel", "pdf"].map((icon) => (
              <button
                key={icon}
                className="w-10 h-10 hover:bg-gray-600 p-2 rounded-full transition-colors"
                onClick={() => HeaderBTNCLICK(icon)}
              >
                <img src={`/Icons/${icon}.svg`} className="object-contain" alt={icon} title={icon} />
              </button>
            ))}
          </ul>
        </div>
      </section>
    </>
  );
};

export default Header;